module.exports = __webpack_public_path__ + "images/42b0e11051553b230978b2047f042bb9.jpg";